import styles from './AboutSection.module.css';
import { FaRocket, FaVrCardboard, FaChartBar, FaBuilding } from 'react-icons/fa';

export default function AboutSection() {
  return (
    <section className={styles.aboutSection}>
      <div className={styles.aboutContent}>
        <h2 className={styles.sectionTitle}>Who We Are</h2>
        <div className={styles.aboutGrid}>
          <div className={styles.aboutCard}>
            <div className={styles.aboutIcon}><FaRocket /></div>
            <h3>AI-Powered Real Estate</h3>
            <p>We're merging real estate with artificial intelligence</p>
          </div>
          <div className={styles.aboutCard}>
            <div className={styles.aboutIcon}><FaVrCardboard /></div>
            <h3>Immersive Experiences</h3>
            <p>Creating property experiences using VR, AR, Data, Design</p>
          </div>
          <div className={styles.aboutCard}>
            <div className={styles.aboutIcon}><FaChartBar /></div>
            <h3>Smart Technology</h3>
            <p>Building search engines, recommendation systems, analytics dashboards</p>
          </div>
          <div className={styles.aboutCard}>
            <div className={styles.aboutIcon}><FaBuilding /></div>
            <h3>Future-Ready Platform</h3>
            <p>Launching India's most future-ready real estate tech platform</p>
          </div>
        </div>
      </div>
      {/* <div className={styles.aboutImage}>
        <img
          src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
          alt="Modern building"
          layout="fill"
          objectFit="cover"
        />
      </div> */}
    </section>
  );
}
